import { apiRequest } from "../api/client";

export interface PublicPaidPilotOffer {
  plan_code: "STARTER" | string;
  plan_name: string;
  duration_days: number;
  upfront_amount_minor_units: number;
  renewal_amount_minor_units: number;
  currency: string;
  renewal_frequency: "MONTHLY" | string;
  tax_policy: string;
  terms_version: string;
}

export interface PublicPaidPilotOfferResponse {
  available: boolean;
  offer: PublicPaidPilotOffer;
}

export const publicPilotOfferQueryKey = [
  "billing",
  "public",
  "pilot-offer",
] as const;

export function fetchPublicPilotOffer(): Promise<PublicPaidPilotOfferResponse> {
  return apiRequest<PublicPaidPilotOfferResponse>(
    "/api/billing/public/pilot-offer",
  );
}

export function paidPilotAmountLabel(
  amountMinorUnits: number | null | undefined,
  currency = "INR",
): string {
  if (
    amountMinorUnits === null
    || amountMinorUnits === undefined
    || !Number.isFinite(Number(amountMinorUnits))
  ) {
    return "Pricing unavailable";
  }
  const amount = Number(amountMinorUnits) / 100;
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toLocaleString("en-IN", {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    })}`;
  }
}

export function paidPilotOfferSentence(
  offer: PublicPaidPilotOffer | null | undefined,
): string {
  if (!offer) {
    return "Review the current Starter paid-pilot terms before subscribing.";
  }
  const upfront = paidPilotAmountLabel(
    offer.upfront_amount_minor_units,
    offer.currency,
  );
  const renewal = paidPilotAmountLabel(
    offer.renewal_amount_minor_units,
    offer.currency,
  );
  return (
    `Pay ${upfront} for ${offer.duration_days}-day Starter access. `
    + `It renews at ${renewal} per month only after you review and confirm `
    + "the exact renewal date."
  );
}
